import { MutationKeys } from './service.js';
import { cleanIHI } from './utils.js';
import WebRequest from './client/WebRequest.js';
export var UpdateUserIHI;
(function (UpdateUserIHI) {
    function api({ data }) {
        return WebRequest.POST('/hi/update-ihi').body({
            ...data,
            identifier: cleanIHI(data.identifier),
        });
    }
    function mutation(client) {
        return {
            mutationFn: (params) => client.executeEmpty(api(params)),
            mutationKey: MutationKeys.VerifyIHI(),
        };
    }
    UpdateUserIHI.mutation = mutation;
})(UpdateUserIHI || (UpdateUserIHI = {}));
export var CheckDuplicateIHI;
(function (CheckDuplicateIHI) {
    function api({ data }) {
        return WebRequest.POST('/hi/check-duplicate').body({
            ...data,
            identifier: cleanIHI(data.identifier),
        });
    }
    function mutation(client) {
        return {
            mutationFn: (params) => client.executeEmpty(api(params)),
            mutationKey: MutationKeys.CheckDuplicateIHI(),
        };
    }
    CheckDuplicateIHI.mutation = mutation;
})(CheckDuplicateIHI || (CheckDuplicateIHI = {}));
export var CheckDuplicateEmail;
(function (CheckDuplicateEmail) {
    function api(email) {
        return WebRequest.POST('/accounts/duplicate-email-check').body({
            email,
        });
    }
    function mutation(client) {
        return {
            mutationFn: (email) => client.execute(api(email)),
            mutationKey: MutationKeys.CheckDuplicateEmail(),
        };
    }
    CheckDuplicateEmail.mutation = mutation;
})(CheckDuplicateEmail || (CheckDuplicateEmail = {}));
